// SETTINGS V2 — nav glyphs. The 8 inline-SVG glyphs ported verbatim from
// design_handoff_settings_v3/settings-shell.jsx lines 14-23 (SgPalette dropped
// with the appearance section). 16px, stroke 1.5, stroke="currentColor" so they
// follow the row text color. NO MUI icons anywhere in settings/v2. Exported as a
// Record keyed by nav key; the rail resolves the glyph by item.key.
import React from "react";

const sg: React.SVGProps<SVGSVGElement> = {
  width: 16,
  height: 16,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 16 16",
};

const SgProfile: React.FC = () => (
  <svg {...sg}>
    <circle cx="8" cy="5.2" r="2.6" />
    <path d="M2.8 13.5 a5.2 4.6 0 0 1 10.4 0" />
  </svg>
);

const SgCompany: React.FC = () => (
  <svg {...sg}>
    <rect x="2.5" y="2" width="7" height="12" rx="0.8" />
    <path d="M9.5 6 L13.5 6 L13.5 14 M2.5 14 L13.5 14" />
    <path d="M4.8 4.5 L7.2 4.5 M4.8 7 L7.2 7 M4.8 9.5 L7.2 9.5" />
  </svg>
);

const SgPin: React.FC = () => (
  <svg {...sg}>
    <path d="M8 14.2 C8 14.2 3 9.8 3 6.3 A5 5 0 0 1 13 6.3 C13 9.8 8 14.2 8 14.2 Z" />
    <circle cx="8" cy="6.3" r="1.7" />
  </svg>
);

const SgBell: React.FC = () => (
  <svg {...sg}>
    <path d="M8 2 a4.1 4.1 0 0 1 4.1 4.1 c0 3 0.8 3.9 1.4 4.5 L2.5 10.6 c0.6-0.6 1.4-1.5 1.4-4.5 A4.1 4.1 0 0 1 8 2 Z" />
    <path d="M6.6 12.8 a1.5 1.5 0 0 0 2.8 0" />
  </svg>
);

const SgPeople: React.FC = () => (
  <svg {...sg}>
    <circle cx="5.6" cy="5.5" r="2.1" />
    <path d="M1.8 12.8 a3.9 3.5 0 0 1 7.6 0" />
    <circle cx="11.2" cy="5.9" r="1.7" />
    <path d="M10.4 9.4 a3.4 3.2 0 0 1 3.8 3.2" />
  </svg>
);

const SgPay: React.FC = () => (
  <svg {...sg}>
    <rect x="1.8" y="4" width="12.4" height="8" rx="1.2" />
    <path d="M1.8 6.8 L14.2 6.8" />
    <path d="M4 10 L6.5 10" />
  </svg>
);

const SgWrench: React.FC = () => (
  <svg {...sg}>
    <path d="M11.5 1.8 a3 3 0 0 0-3.2 4.1 L3 11.2 a1.3 1.3 0 1 0 1.8 1.8 L10.1 7.7 A3 3 0 0 0 14 4 L12 6 L10.3 5.5 L9.8 3.8 Z" />
  </svg>
);

const SgTruck: React.FC = () => (
  <svg {...sg}>
    <path d="M1.8 3.5 L9.5 3.5 L9.5 11 L1.8 11 Z" />
    <path d="M9.5 6 L12.6 6 L14.2 8 L14.2 11 L9.5 11" />
    <circle cx="4.4" cy="12.2" r="1.3" />
    <circle cx="11.6" cy="12.2" r="1.3" />
  </svg>
);

// B7-FE1 (plan §6A.4) — digital nameplates: a QR-in-frame motif (plate outline
// with corner finders + a code block), drawn in the same 16px / stroke-1.5 /
// currentColor idiom as the eight ported glyphs. Inline SVG — no MUI icons.
const SgNameplate: React.FC = () => (
  <svg {...sg}>
    <rect x="1.8" y="2.8" width="12.4" height="10.4" rx="1.2" />
    <path d="M4.4 5.4 L6.2 5.4 L6.2 7.2 L4.4 7.2 Z" />
    <path d="M4.4 9 L6.2 9 L6.2 10.8 L4.4 10.8 Z" />
    <path d="M8.2 5.4 L10 5.4 L10 7.2 L8.2 7.2 Z" />
    <path d="M8.2 9.2 L8.2 10.8 M9.9 9.2 L9.9 10.8 M11.6 9.2 L11.6 10.8" />
  </svg>
);

// Keyed by nav key (identical to legacy nav keys / useSettingsV2Nav item.key).
const settingsV2NavGlyphs: Record<string, React.FC> = {
  profile: SgProfile,
  notifications: SgBell,
  company: SgCompany,
  locations: SgPin,
  nameplates: SgNameplate,
  team: SgPeople,
  pricing: SgPay,
  service: SgWrench,
  shipping: SgTruck,
};

export default settingsV2NavGlyphs;
